/**
 * Maps an array of data items to a template.
 * @param {Array} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapDataToTemplate = (results, $itemTemplate) => {
    if (Array.isArray(results) && results.length) {
        return results.map(entry => {
            const $item = $itemTemplate.clone();
            $item.find('[data-subline]').text(entry.sector).toggle(Boolean(entry.sector));
            $item.find('[data-title]').text(`${entry.name}`);
            $item.find('[data-text]').text(entry.formattedAddress);
            $item.find('[data-img]').attr('src', entry.image);
            let diff = 50; /* eslint no-unused-vars: "off" */
            switch (entry.imagealign) {
                case 1: // Left
                    diff = 0;
                    break;
                case 3: // Right
                    diff = 100;
                    break;
                case 2: // Center
                case 0:
                default:
                    break;
            }

            $item.find('[data-link]').attr('href', entry.url);
            $item.addClass(entry.color);

            return $item.get(0);
        });
    }
    return []; // Return an empty array if the input is not valid
};


export default mapDataToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/references/mapDataToTemplate.js